import * as Models  from '../commonModels';
import * as TyreStateModels from '../tyre/tyreState';
import * as OrderModels from '../order/order';
import * as CarModels from '../car/car';
import * as GarageModels from '../garage/garage';
import * as CustomerModels from '../customer/customer';
import * as SpecificationModels from '../specification/specification';
import * as TyreModels from '../tyre/tyrePreview';


export class DepositeListModel extends Models.ListBaseModelWithAdditonalReturnInformation {
    Items: DepositeModel[];
    TotalTyreStates: number;
    SeasonWinter: number;
    SeasonSummer: number;
}

export class DepositeModel {
  public DepositeId: number;
  public AddDate: Date;
  public Tyre: string;
  public IsUnspecified: boolean;
  public Note: string;
  public TyreCount: number;
  public GarageDepositeNumber: string;
  public Age: number;
  public IsRim: boolean;
  public TyreDiameter: number;
  public RelocationCourierGarageOrderDelayDays: number;
  public IsLowThread: boolean;
  public InventoryActionDate: Date;
  public IsInventoryChange: boolean;
  public TyreStates: TyreStateModels.TyreStateModel[];
  public TyreStatesPreviews: TyreStateModels.TyreStatePreviewModel[];
  public IsDepositeInventoryNote: boolean;
  public OrderType: string;
  public Orders: OrderModels.OrderPreviewModel[];
  public IsShipment: boolean;
  public Car: CarModels.CarPreviewModel;
  public Customer: CustomerModels.CustomerPreviewModel;
  public Garage: GarageModels.GaragePreviewModel;
  public Specification: SpecificationModels.SpecificationPreviewModel;
  public Processing: boolean;
  public IsReadOnly: boolean;
  public IsTyreStateReadOnly: boolean;
  public TyresManualDescription: string;
  //Czy na poszczególnych oponach są jakiekolwiek notatki
  public IsTyreStatesNote: boolean;
  public IsInventoryConfirmed: boolean;
  public TyrePreview: TyreModels.TyrePreviewModel;
  public IsInventoryOn: boolean;
  public IsInventoryConfirmationOn: boolean;
  public DepositeInventoryStatusId: number;
  //Do użycia tylko w przypadku metody set-inventory
  public DepositeInventoryNote: string;
  //Czy można zresetować flagę inw
  public IsInventoryResetOn: boolean;
  //Czy można wykonywać zamówienia na danym depozycie.
  public IsCreatingOrderAvailable: boolean;
  public RegistrationNumber: string;
  public IsSelectedForProcess: boolean;
  public IsAldGarageVisitAvailable: boolean;
  public IsAldRelocationAvailable: boolean;
  public IsAldGarageVisitRequestAvailable: boolean;
  /// Czy jakakolwiek opona z depozytu jest skojażona z aktywnym zleceniem
  public IsAnyTyreBlockedByOrder: boolean;
}





export class DepositePreviewListModel extends Models.ListBaseModel {
  Items: DepositePreviewModel[];
  TotalTyreStates: number;
  SeasonWinter: number;
  SeasonSummer: number;
  IsCourierPackagesPickupCallAllowed: boolean;
  NewOrders: OrderModels.OrderPreviewModel[];
}

export class DepositePreviewModel {
  public DepositeId: number;
  public AddDate: Date;
  public Tyre: string;
  public IsUnspecified: boolean;
  public Note: string;
  public TyresManualDescription: string;
  public TyreCount: number;
  public GarageDepositeNumber: string;
  public Age: number;
  public IsRim: boolean;
  public TyreDiameter: number;
  public RelocationCourierGarageOrderDelayDays: number;
  public IsLowThread: boolean;
  public InventoryActionDate: Date;
  public IsInventoryChange: boolean;
  public TyreStatesPreviews: TyreStateModels.TyreStatePreviewModel[];
  public IsShipment: boolean;
  public Garage: GarageModels.GaragePreviewModel;
  public IsReadOnly: boolean;
  public TyrePreview: TyreModels.TyrePreviewModel;
  //Czy na poszczególnych oponach są jakiekolwiek notatki
  public IsTyreStatesNote: boolean;
  //Czy można wykonywać zamówienia na danym depozycie.
  public IsCreatingOrderAvailable: boolean;
  public Rim: string;
  //Konkatencja ID i nr depozytu
  public Name: string;
}

export enum DepositeInventoryStatusesType {
  NotInventoried = 1,
  Confirmed = 2,
  Changed = 3
}

